import React from "react"
import { MessageContainer, Message, SecondMessage } from "./style"

const ContactMessage = ({ success }) => {
  if (success) {
    return (
      <MessageContainer>
        <Message>Message sent successfuly</Message>
        <SecondMessage>Thank you!</SecondMessage>
      </MessageContainer>
    )
  } else {
    return (
      <MessageContainer>
        <Message>There was an error, try again later...</Message>
        <SecondMessage>We're sorry</SecondMessage>
      </MessageContainer>
    )
  }
}

export default ContactMessage
